const aliases = {
  calendar: "tabler-calendar",
  collapse: "tabler-chevron-up",
  complete: "tabler-check",
  cancel: "tabler-x",
  close: "tabler-x",
  delete: "tabler-x",
  clear: "tabler-x",
  success: "tabler-circle-check",
  info: "tabler-info-circle",
  warning: "tabler-alert-circle",
  error: "tabler-x",
  prev: "tabler-chevron-left",
  next: "tabler-chevron-right",
  checkboxOn: "tabler-square-check",
  checkboxOff: "tabler-square",
  checkboxIndeterminate: "tabler-square-dot",
  delimiter: "tabler-circle",
  sort: "tabler-arrow-up",
  expand: "tabler-chevron-down",
  menu: "tabler-menu-2",
  subgroup: "tabler-caret-down",
  dropdown: "tabler-chevron-down",
  radioOn: "tabler-circle-check",
  radioOff: "tabler-circle",
  edit: "tabler-pencil",
  ratingEmpty: "tabler-star",
  ratingFull: "tabler-star-filled",
  ratingHalf: "tabler-star-half",
  loading: "tabler-refresh",
  first: "tabler-player-skip-back",
  last: "tabler-player-skip-forward",
  unfold: "tabler-arrows-move-vertical",
  file: "tabler-paperclip",
  plus: "tabler-plus",
  minus: "tabler-minus",
  sortAsc: "tabler-arrow-up",
  sortDesc: "tabler-arrow-down",
};

export const iconify = {
  component: (props) =>
    h(props.tag, {
      ...props,
      class: [props.class, props.icon],

      // Remove used props from DOM rendering
      tag: undefined,
      icon: undefined,
    }),
};
export const icons = {
  defaultSet: "iconify",
  aliases,
  sets: {
    iconify,
  },
};
